"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditActionType = void 0;
/**
 * Daily Entry correction/audit history — read-only view over the existing
 * `AuditLog` table (no schema change; see
 * docs/NORMAX_PERFORMANCE_DAILY_ENTRY_AUDIT_TRAIL_FORENSICS.md and
 * docs/NORMAX_PERFORMANCE_DAILY_ENTRY_AUDIT_HISTORY_IMPLEMENTATION_REPORT.md).
 *
 * Deliberately NEVER the raw Prisma `AuditLog` row — no `companyId`, no raw
 * `changedBy` UUID (resolved to email/role instead), no raw `oldValue`/
 * `newValue` JSON blobs (only an already-computed, HONEST field-level diff,
 * limited to the fields the audit write path actually captures on both
 * sides — see `DailyEntryHistoryFieldChangeDto`).
 */
/** Mirrors the literal `action` strings AuditService.record() is actually called with in daily-entry.service.ts — never invented. */
exports.AuditActionType = {
    CREATE: "CREATE",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    STATUS_CHANGE: "STATUS_CHANGE",
};
//# sourceMappingURL=daily-entry-history.js.map